module.exports = __webpack_public_path__ + "da626909fcd176b9d7ab4e4805a5aaf2.png";